<ng-container>
  <div class="organization-details-container pr-0 pl-0" [formGroup]="formGroup">
    <div class="organization-details-container-form pr-0 pl-0 col-12 col-lg-8">
      <div id="control-businessName">
        <!-- organizationName -->
        <app-control-wrapper [control]="formGroup.get('businessName')">
          <label for="businessName" control-label>
            {{ "LABELS.ORGANIZATION_NAME" | translate }}
          </label>
          <input
            type="text"
            [formControl]="formGroup.get('businessName')"
            class="form-control"
            id="businessName"
            name="businessName"
            [placeholder]="'FORM_PLACEHOLDER.BUSINESS_NAME' | translate"
            control-wrapper
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [dropSpecialCharacters]="false"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          />
        </app-control-wrapper>
      </div>
      <identifier-qualifier-update [formGroup]="formGroup" [isModalPlacement]="true" [errors]="{}"></identifier-qualifier-update>
    </div>
    <div class="d-none d-lg-block col-4">
      <div class="organization-details-container-description">
        <span [innerHTML]="'LABELS.BUSINESS_INFO_DESCRIPTION_SHORT' | translate"></span>
      </div>
    </div>
  </div>
</ng-container>
